import { render } from "./Regulation.vue?vue&type=template&id=369c4c62"
import script from "./Regulation.vue?vue&type=script&lang=js"
export * from "./Regulation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__